export default "__VITE_ASSET__f4286a1d__"